import axios from "axios";

class AuditingService {

    constructor() {
        this.apiBaseUrl = process.env.REACT_APP_AUDIT;
        this.restClient = axios.create({
            baseURL: this.apiBaseUrl
        });
    }

    addAuditEvent(journeyName, message, state, accountNumber, msisdn, componentName,additionalParam1,additionalParam2) {
        return this.restClient.post('/event',{
            "accountNumber": accountNumber ? accountNumber : "",
            "additionalParam1": additionalParam1,
            "additionalParam2": additionalParam2,
            "additionalParam3": "",
            "componentName": componentName,
            "journeyName": journeyName,
            "message": message,
            "msisdn": msisdn ? msisdn : "",
            "state": state
        }).then(res => {
           // console.log(res)
        }).catch(error => {
            console.error('Error from UI auditing ', error);
        });
    }

}

export default new AuditingService();
